import { EPartsLower } from '../../../types/fio';

export function getCurrentPartFIO(query: string[]) {
  if (query.length === 2) {
    return EPartsLower.Name;
  }

  if (query.length === 3) {
    return EPartsLower.Patronymic;
  }

  return EPartsLower.Surname;
}
